const principles = [
  { icon: 'ri-tools-line', title: '真实整理', desc: '每一部作品都经过剧情类型核对，拒绝标题党与空壳推荐。' },
  { icon: 'ri-leaf-line', title: '持续更新', desc: '紧跟连载动态，让聚合页始终保有新鲜可读的内容。' },
  { icon: 'ri-group-line', title: '读者导向', desc: '根据漫迷反馈调整分类与排序，把真正好看的作品放到前排。' },
  { icon: 'ri-shield-check-line', title: '分类清晰', desc: '用清晰的标签与分类降低挑选成本，让你少走弯路。' },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-800">
              <i className="ri-heart-3-fill" />
              关于我们
            </span>
            <h2 className="font-heading mb-5 text-2xl font-black text-foreground-950 md:text-4xl">
              一个认真做恋爱后宫漫画聚合的站点
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>
                羞羞动漫漫画是一个专注恋爱与后宫题材的聚合站，围绕校园、同居、暧昧与逆后宫四大方向，持续整理高口碑作品。
                我们深知找一部合口味的漫画有多费时，因此用清晰的分类和标签，帮你把挑选成本降到最低。
              </p>
              <p>
                网站定位是一站式的恋爱后宫资源聚合入口：无论你想看青涩的校园暗恋，还是温馨的同居日常，
                或是充满张力的暧昧拉扯与多男主的逆后宫抉择，都能在这里快速锁定方向。
              </p>
              <p>
                我们的内容原则始终是"真实、清晰、可持续"——不堆砌标题、不推荐空洞作品，
                以读者口碑为依据持续优化推荐排序，让每一个入坑的人都能满载而归。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((item) => (
              <article
                key={item.title}
                className="rounded-lg bg-background-100/70 p-5 transition-colors hover:bg-background-200/60"
              >
                <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-lg text-secondary-900">
                  <i className={item.icon} />
                </span>
                <h3 className="mb-1.5 text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}